export default "__VITE_ASSET__Dn4rpmcv__"